import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import reportWebVitals from "./reportWebVitals";

import { ThemeProvider, createTheme } from "@mui/material";
import { AuthProvider } from "./components/auth/AuthProvider";
import { AppRouter } from "./router";

const theme = createTheme({
  palette: {
    mode: "light", // light mode for white background
    primary: {
      main: "#1f1f1f", // navbar dark background (old dark mode tone)
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#1f1f1f", // dark navbar
          color: "#fff",
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff",
          color: "#121212" // dark table header
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: "#6bb9a6",
          color: "#fff",
          fontWeight: "bold",
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
